import React from 'react';
import Component from '@vfuk/core-functional-picker-item';
const FunctionalPickerItem = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default FunctionalPickerItem;
